  import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

  var axios_instance = get_axios_instance(api_variables.SERVICE_PAYROLL_SUMMARY);
  var axios_instance_run = get_axios_instance(api_variables.SERVICE_RUN_PAYROLL);

  const state = {
      data: [],
      summary: {},
      isFetching: false,
      isSaving: false,
      isDeleting: false,
      payrollMonth: "",
      payrollYear: ""
  };

  const mutations = {
      set: (state, payload) => {
          state.data = payload;
      },

      setSummaryData: (state, payload) => {
          if (payload) {
              state.summary = payload;
          }
      },

      runPayroll: (state, payload) => {
          state.summary = payload;
          // state.data.push(payload);
      },

      payrollMonth: (state, payload) => {
          state.payrollMonth = payload.month;
          state.payrollYear = payload.year;
      },

      setFetching: (state, payload) => {
          state.isFetching = payload;
      },

      setSaving: (state, payload) => {
          state.isSaving = payload;
      },

      setDeleting: (state, payload) => {
          state.isDeleting = payload;
      },
  }

  const actions = {

      async fetchAll({ commit }, payload) {
          try {
              commit("setFetching", true);
              let res = await axios_instance.post('/', payload);
              commit("setFetching", false);
              if (res.status == 200) {
                  //commit("set", payload);
              }
              //console.log("res of state",res);
              return res;
          } catch (err) {
              throw errorHandler(err.response);
          }
      },

      async fetchSummaryData({ commit }, payload) {
          try {
              commit("setFetching", true);
              let res = await axios_instance.get(`/`, {
                  params: {
                      paygroupId: payload
                  }
              });
              commit("setFetching", false);
              if (res.status == 200) {
                  commit("setSummaryData", res.data.rows);
              }
              return res;
          } catch (err) {
              throw errorHandler(err.response);
          }
      },

      async create({ commit }, payload) {
          try {
              commit("setSaving", true);
              let res = await axios_instance_run.post('/', payload);
              commit("setSaving", false);
              if (res.status == 200) {
                  commit("runPayroll", payload);
              }
              return res;
          } catch (err) {
              throw errorHandler(err.response);
          }
      },

      async setPayrollMonth({ commit }, payload) {
          try {
              commit("setSaving", true);
              commit("payrollMonth", payload);
              commit("setSaving", false);
          } catch (err) {
              throw errorHandler(err.response);
          }
      },
  }

  export default {
      namespaced: true,
      state,
      mutations,
      actions
  }